import { type StepData } from '@diligentcorp/atlas-theme-mui-lens';
import { useCallback, useMemo, useState } from 'react';

export const useStepper = (stepLabels: string[]) => {
  const totalSteps = stepLabels.length;
  const [currentStep, setCurrentStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState<Set<number>>(new Set());

  const steps: StepData[] = useMemo(
    () =>
      stepLabels.map((label, index) => ({
        label,
        completed: completedSteps.has(index),
      })),
    [stepLabels, completedSteps],
  );

  const goToNextStep = useCallback(() => {
    setCompletedSteps((prev) => new Set(prev).add(currentStep));
    if (currentStep < totalSteps - 1) {
      setCurrentStep((step) => step + 1);
    }
  }, [currentStep, totalSteps]);

  const goToPreviousStep = useCallback(() => {
    setCurrentStep((step) => Math.max(0, step - 1));
  }, []);

  return {
    currentStep,
    steps,
    goToNextStep,
    goToPreviousStep,
    isFirstStep: currentStep === 0,
    isLastStep: currentStep === totalSteps - 1,
  };
};
